/*------------------------------------*\
    BABEL POLYFILL
\*------------------------------------*/
import "babel-polyfill";

/*------------------------------------*\
    MODULES
\*------------------------------------*/
import TypeMate from 'typemate';
import Autocomplete from './modules/autocomplete';
import Breadcrumbs from './modules/breadcrumbs';
import BullList from './modules/bull-list';
import Carousel from './modules/carousel';
import Contacts from './modules/contacts';
import CopyToClipboard from './modules/copy-to-clipboard';
import DownloadsTable from './modules/downloads-table';
import FiltersForm from './modules/filters-form';
import LinearToggle from './modules/linear-toggle';
import LoadingButton from './modules/loading-button';
import Map from './modules/map';
import MapInternational from "./modules/map-international";
import NewsletterSignup from "./modules/newsletter-signup";
import RangeSlider from './modules/range-slider';
import Search from './modules/search';
import SiteHead from './modules/site-head';
import SiteNav from './modules/site-nav';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'autocomplete':

                        let autocompleteInstance = new Autocomplete(item);

                        autocompleteInstance.init();

                        break;

                    case 'breadcrumbs':

                        let breadcrumbsInstance = new Breadcrumbs(item);

                        breadcrumbsInstance.init();

                        break;

                    case 'bull-list':

                        let bullListInstance = new BullList(item);

                        bullListInstance.init();

                        break;

                    case 'carousel':

                        let carouselInstance = new Carousel(item);

                        carouselInstance.init();

                        break;

                    case 'contacts':

                        let contactsInstance = new Contacts(item);

                        contactsInstance.init();

                        break;

                    case 'copy-to-clipboard':

                        let copyToClipboardInstance = new CopyToClipboard(item);

                        copyToClipboardInstance.init();

                        break;

                    case 'downloads-table':

                        let downloadsTableInstance = new DownloadsTable(item);

                        downloadsTableInstance.init();

                        break;

                    case 'filters-form':

                        let filtersFormInstance = new FiltersForm(item);

                        filtersFormInstance.init();

                        break;

                    case 'linear-toggle':

                        let linearToggleInstance = new LinearToggle(item);

                        linearToggleInstance.init();

                        break;

                    case 'loading-button':

                        let loadingButtonInstance = new LoadingButton(item);

                        loadingButtonInstance.init();

                        break;

                    case 'map':

                        let mapInstance = new Map(item);

                        mapInstance.init();

                        break;

                    case 'map-international':

                        let mapInternationalInstance = new MapInternational(item);

                        mapInternationalInstance.init();

                        break;

                    case 'newsletter-signup':

                        let newsletterSignupInstance = new NewsletterSignup(item);

                        newsletterSignupInstance.init();

                        break;

                    case 'range-slider':

                        let rangeSliderInstance = new RangeSlider(item);

                        rangeSliderInstance.init();

                        break;

                    case 'search':

                        let searchInstance = new Search(item);

                        searchInstance.init();

                        break;

                    case 'site-head':

                        let siteHeadInstance = new SiteHead(item);

                        siteHeadInstance.init();

                        break;

                    case 'site-nav':

                        let siteNavInstance = new SiteNav(item);

                        siteNavInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        const typeMateInstance = new TypeMate();
        typeMateInstance.apply();
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();